import Vue from "vue";

export default {
  install(vue: Vue): void {
    // @ts-expect-error ts(2339)
    vue.prototype.$bus = new Vue();
  },
};
